module.exports = __webpack_public_path__ + "img/elementlengths_jas.0e4a800f.png";